<template>
    <div class="root">
        <div class="hh-profile-container margin-top-50">
            <div class="panel panel-default" ref="top">
                <div class="container-fluid">
                    <div class="row margin-top-10">
                        <div class="col-sm-12 ">
                            <h1 class="text-normal text-center">
                                Reset Password
                            </h1>
                            
                        </div>
                       
                        <div class="col-sm-12 section-title">
                            <div class="text-left text-danger" v-if="changePasswordErrors.has('internalError')">
                                There was an error resetting your password. Please try again later.
                            </div>
                        </div>
                    </div>
                    <div v-if="loading" class="section-body margin-top-50 margin-bottom-50">
                        <LoadingAnimation/>
                    </div>

                    <form action="#"
                          @submit.prevent="submitForm"
                          class="form"
                    >
                        <div class="section-body margin-bottom-50" v-show="!loading">
                            <div class="row">
                                <div class="form-group col-sm-12">
                                    <password-container
                                            v-model="formData.password"
                                            autocomplete="current-password"
                                            placeholder="Current password"
                                            :required="true"
                                            :show-hint="false"
                                    />
                                    <div>
                                        <div class="invalid-feedback-red" v-if="changePasswordErrors.has('password')">
                                            {{changePasswordErrors.get('password')}}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="form-group col-sm-12">
                                    <password-container
                                            v-model="formData.new_password"
                                            autocomplete="off"
                                            placeholder="Enter new password"
                                            :required="true"
                                            :role="role"
                                    />
                                    <div class="invalid-feedback-red" v-if="changePasswordErrors.has('new_password')">
                                        {{changePasswordErrors.get('new_password')}}
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="form-group col-sm-12">
                                    <password-container
                                            v-model="formData.confirm_password"
                                            autocomplete="off"
                                            placeholder="Confirm new password"
                                            :required="true"
                                            :show-hint="false"
                                            :role="role"
                                    />
                                    <div class="invalid-feedback-red" v-if="changePasswordErrors.has('confirm_password')">
                                        {{changePasswordErrors.get('confirm_password')}}
                                    </div>
                                </div>
                            </div>

                        
                <div class="row hh-form-btn-wrapper margin-bottom-20 margin-top-20">
                        <div class="form-group col-sm-6">
                          <button type="button" v-on:click="backAction"
                                  class="btn hh-btn back-btn" name="Cancel">
                            Cancel
                          </button>
                        </div>
                        <div class="form-group col-sm-6">
                          <button type="submit" :disabled="!isFormReady"
                                  class="btn save-btn hh-btn-green" name="Save changes">
                            Save Changes
                          </button>
                        </div>
                      </div>

                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  import Alert from '../../components/form/elements/Alert'
  import LoadingAnimation from '../../components/LoadingAnimation'
  import PasswordContainer from '../../components/form/elements/PasswordContainer'
  import { scrollTo } from '../../utils/componentHelper'
  
  export default {
    name: 'ChangePasswordView',

    components: {
      Alert,
      LoadingAnimation,
      PasswordContainer
    },

    props: {},

    beforeMount () {
          if (_.isEmpty(this.profileData)) {
            this.fetchData().then(() => {
              this.analyseUserData()
            })
          } else {
            this.analyseUserData()
          }
        },

    mounted () {
      scrollTo(this.$refs['top'])
      this.loading = false
      this.isFormReady = true
    },

    data: () => {
      return {
        isFormReady: true,
        loading: true,
        config: {},
        userRoles: Array,
        formData: {
          password: null,
          new_password: null,
          confirm_password: null,
          informationType: 'ChangePassword',
        },
      }
    },

    methods: {
      ...mapActions('profile', ['fetchData', 'storeInformation']),
      ...mapGetters('profile', ['profileData']),

      backAction () {
        this.$router.back()
      },

      submitForm () {
        this.isFormReady = false
        this.loading = true

        if (this.processFormData()) {
          this.sendFormData()
        }

        return true
      },

        analyseUserData () {
          if (!_.isEmpty(this.profileData)) {
            this.fillUserData()
          }
      },

       fillUserData () {
        this.userRoles = this.profileData.data.attributes.roles
      },

      processFormData () {
        return true
      },

      sendFormData () {
        this.storeInformation(this.formData).then(() => {
          if (this.changePasswordStatus === 'success') {
            this.$store.commit('setAlert', {
              message: 'Password changed.',
              type: 'bg-success'
            })
            this.$router.push({name: 'profile'})
          }

          this.isFormReady = true
          this.loading = false
        })
      },

    },

    computed: {
      ...mapGetters('profile', ['profileData']),
      ...mapGetters(['alert']),

      changePasswordStatus: {
        get () {
          return this.$store.getters['profile/storeInformationStatus'](this.formData.informationType)
        },
      },

      changePasswordErrors: {
        get () {
          return this.$store.getters['profile/storeInformationErrors'](this.formData.informationType)
        },
      },

      role () {
        if (!_.isEmpty(this.userRoles) && this.userRoles.includes('organizer')) {
          return 'organizer'
        }

        return 'donor'
      },
    },
  }
</script>

<style lang="scss" scoped>
	.svg.eye {
		margin-bottom: 5px;
	}
  
    .root::v-deep {
        @import '../../../style/pages/profile';
    }

    h1 {
      font-family: Circular Std;font-style: normal;font-weight: bold;font-size: 26px !important; line-height: 33px !important;letter-spacing: -0.01em;color: #000000;
    }
</style>